import { firstLetterUpperCase } from './stringFormatter';
import { Programme, ProgrammeActivityType } from 'src/@types/programme';

const generateProgrammeLink = (merchantCode?: string, programmeCode?: string) => {
  if (!merchantCode || !programmeCode) {
    return;
  }

  return `${process.env.REACT_APP_MY_CC_URL}/RM-${merchantCode}/my-cc?programmeCode=${programmeCode}`;
};

const getProgrammeByCode = (code: string, programmes?: Programme[]) => {
  return programmes?.find((programme) => programme?.code === code);
};

const getProgrammeNameByType = (type?: string) => {
  if (!type) {
    return '';
  }

  switch (type) {
    case ProgrammeActivityType.FLIGHT:
      return `${firstLetterUpperCase(type)} offsetting`;
    default:
      return `${firstLetterUpperCase(type)} programme`;
  }
};

export { generateProgrammeLink, getProgrammeByCode, getProgrammeNameByType };
